import { Link } from "react-router-dom";
import styles from "../../constants/styles";

const Footer = () => {
  return (
    <div className="w-screen bg-green-500 flex flex-col items-center py-8 space-y-4">
      <div className="flex flex-row space-x-6">
        <Link
          to="/imprint"
          className={`${styles.standardText} ${styles.hoverShrinkEffect}`}
        >
          Imprint
        </Link>
        <Link
          to="/privacy-policy"
          className={`${styles.standardText} ${styles.hoverShrinkEffect}`}
        >
          Privacy Policy
        </Link>
      </div>

      <span className={styles.standardText}>Made in Germany 🇩🇪</span>
    </div>
  );
};

export default Footer;
